export const API_URL = "https://api.montenegromice.com/api";

// export const API_URL = "https://montenegromice.com/mice-api";

// export const API_URL = "http://127.0.0.1:8000/api";
